import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8997_127052)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.63698 7.85647H7.62889V14.2872H5.63698V7.85647Z",
				fill: "#565CDE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.62256 7.0119C7.27473 7.0119 7.80052 6.48106 7.80052 5.82383C7.80052 5.1666 7.27473 4.63576 6.62256 4.63576C5.97038 4.63576 5.4446 5.1666 5.4446 5.82383C5.4446 6.48106 5.97038 7.0119 6.62256 7.0119Z",
				fill: "#565CDE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.027 9.46928C11.2282 9.46928 10.8136 10.0052 10.8136 10.9101V14.2822H8.90261V7.85149H10.8136V8.716C10.8136 8.716 11.3849 7.65432 12.7499 7.65432C14.1149 7.65432 15.0907 8.48849 15.0907 10.2125V14.2873H13.1089V10.9101C13.1089 9.98495 12.76 9.46928 12.027 9.46928Z",
				fill: "#565CDE"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 -0.000244141C4.47714 -0.000244141 0 4.4769 0 9.99976C0 15.5226 4.47714 19.9998 10 19.9998C15.5229 19.9998 20 15.5226 20 9.99976C20 4.4769 15.5229 -0.000244141 10 -0.000244141ZM0.758342 9.99976C0.758342 4.89572 4.89596 0.758098 10 0.758098C15.104 0.758098 19.2417 4.89572 19.2417 9.99976C19.2417 15.1038 15.104 19.2414 10 19.2414C4.89596 19.2414 0.758342 15.1038 0.758342 9.99976Z",
				fill: "#565CDE"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8997_127052",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgLn;
